import React from "react";
/* css comes in adminMember.css */

import Form from "react-bootstrap/Form";
import { getInitial } from "../../../../../utils/Engagement";
import { IP } from "../../../../../internalServer"

const IndividualsMember = ({
  teacher,
  inEditingMode,
  setEditingAllMembersDetails,
  editingAllMembersDetails,
  setDeletingAllMembersDetails,
  deletingAllMembersDetails,
}) => {
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const { deletingTeachers } = deletingAllMembersDetails;
  const handleRoleChange = (e) => {
    !editingAllMembersDetails.some((member) => member.memberId === teacher?.id)
      ? setEditingAllMembersDetails((prev) => [
        ...prev,
        {
          previousRole: teacher?.role,
          nextRole: e.target.value,
          memberId: teacher?.id,
        },
      ])
      : setEditingAllMembersDetails(
        editingAllMembersDetails.map((item) => {
          if (item.memberId === teacher?.id) {
            return { ...item, nextRole: e.target.value };
          } else {
            return item;
          }
        })
      );
  };

  const handleDeleteMember = () => {
    if (deletingTeachers.includes(teacher.id)) {
      const newTeachersList = deletingTeachers.filter((a) => a !== teacher.id);
      setDeletingAllMembersDetails((prevState) => ({
        ...prevState,
        deletingTeachers: newTeachersList,
      }));
    } else {
      setDeletingAllMembersDetails((prev) => ({
        ...prev,
        deletingTeachers: [...prev.deletingTeachers, teacher.id],
      }));
    }
  };
  return (
    <>
      <div className="col-12 p-0 d-flex align-items-center">
        <div className="col-8 p-0 mt-3 gap-2 d-flex align-items-center">
          <div className="d-flex align-items-center justify-content-center">
            {
              teacher?.role === "moderator" || "B4sAdmin" ?
                < img
                  src={
                    teacher?.teacher?.profilePicture
                      ? IP + teacher?.teacher?.profilePicture.replace(/^\./, "")
                      : teacher?.teacher?.gender === "M"
                        ? "/images/Teacher_Male.jpg"
                        : teacher?.teacher?.gender === "F"
                          ? "/images/Teacher_Female.png"
                          : "/images/default image.png"
                  }
                  alt="icon"
                  className=""
                  style={{ width: "25px", height: "25px", borderRadius: "50%", cursor: "pointer" }}
                  key={teacher?.teacher?.profilePicture}
                  onError={(e) => {
                    if (teacher?.teacher?.gender === "M") {
                      e.target.src = "/images/Teacher_Male.jpg"
                    } else if (teacher?.teacher?.gender === "F") {
                      e.target.src = "/images/Teacher_Female.png"
                    } else {
                      e.target.src = "/images/default image.png"
                    }
                  }}
                /> : <img style={{ width: "25px", height: "25px", borderRadius: "50%", cursor: "pointer", marginRight: "10px" }} src="/images/default image.png" alt="" />
            }
          </div>
          <span>{teacher?.teacher?.name}</span>
          {teacher?.teacher.id === teacher_id && (
            <span className="you">
              {/* (you) */}
            </span>
          )}
        </div>
        {inEditingMode ? (
          <div className=" gap-3 d-flex">
            {teacher?.teacher.id !== teacher_id && (
              <Form.Select
                onChange={(e) => handleRoleChange(e)}
                defaultValue={teacher?.role}
                className={`${editingAllMembersDetails.some(
                  (member) => member.memberId === teacher?.id
                ) && `select_option_change`
                  } custom-select`}
                size="sm"
              >
                <option value="admin">ADMIN</option>
                <option value="moderator">MODERATOR</option>
                <option value="member">MEMBER</option>
              </Form.Select>
            )}
            {!deletingTeachers.includes(teacher.id) ? (
              <>
                {teacher?.teacher.id !== teacher_id && (
                  <img
                    onClick={handleDeleteMember}
                    src="/images/Dustbin.svg"
                    alt=""
                  />
                )}
              </>
            ) : (
              <img
                onClick={handleDeleteMember}
                src="/images/redDustbin.svg"
                alt=""
              />
            )}
          </div>
        ) : (
          <span className="roleStyle">
            {teacher?.role?.toUpperCase()
              // + teacher?.role?.slice(1)
            }
          </span>
        )}
      </div>
    </>
  );
};

export default IndividualsMember;
